// Bandeja de avisos (D5): fuente de verdad durable; el push es solo un canal adicional.
import type { WorkType } from '../domain/orders.ts';
import { AppFailure, toAppError } from './errors.ts';
import { supabase } from './supabase.ts';

export type NotificationType = 'assignment' | 'parts_dispatched' | 'parts_requested' | 'work_done' | 'work_returned';

export const NOTIFICATION_LABELS: Record<NotificationType, string> = {
  assignment: 'Nueva orden asignada',
  parts_dispatched: 'Repuesto despachado',
  parts_requested: 'Solicitud de repuestos',
  work_done: 'Trabajo listo',
  work_returned: 'Orden objetada',
};

export interface InboxItem {
  id: string;
  type: NotificationType;
  folio: string;
  work_type: WorkType;
  order_id: string;
  created_at: string;
  read_at: string | null;
}

function fail(error: unknown): never {
  throw new AppFailure(toAppError(error));
}

export async function listInbox(limit = 50): Promise<InboxItem[]> {
  const { data, error } = await supabase
    .from('notifications')
    .select('id, type, folio, work_type, order_id, created_at, read_at')
    .order('created_at', { ascending: false })
    .order('id', { ascending: false })
    .limit(limit);
  if (error) fail(error);
  return data as InboxItem[];
}

export async function unreadCount(): Promise<number> {
  const { count, error } = await supabase
    .from('notifications')
    .select('id', { count: 'exact', head: true })
    .is('read_at', null);
  if (error) fail(error);
  return count ?? 0;
}

export async function markRead(ids: string[] | null): Promise<void> {
  const { error } = await supabase.rpc('mark_notifications_read', ids ? { p_ids: ids } : {});
  if (error) fail(error);
}
